import { t } from '@hefe/i18n';
import {
  PracticeTimesSchedule,
  RequestBasePostPracticeTimesSchedule,
} from '@hefe/models';
import {
  BasketballPracticeTimesApi,
  BasketballPracticeTimesSlice,
  ModalsSlice,
} from '@hefe/store';
import { formatDatabaseDate } from '@hefe/utils';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../store/store';
import CustomForm from '../../../core/components/form/custom-form';

interface AddEditPracticeTimesScheduleFormProps {
  schedule?: PracticeTimesSchedule;
  duplicate?: boolean;
}

export default function AddEditPracticeTimesScheduleForm(
  props: AddEditPracticeTimesScheduleFormProps
) {
  const { schedule, duplicate } = props;

  const dispatch = useAppDispatch();
  const [createPracticeTimesDraft] =
    BasketballPracticeTimesApi.useCreatePracticeTimesScheduleMutation();

  const modalState = useSelector(ModalsSlice.modalsState);

  const onSubmit = (
    values: RequestBasePostPracticeTimesSchedule,
    resetForm: any
  ) => {
    const closeModal = ModalsSlice.modalsActions.closeModal;
    const setModalLoading = ModalsSlice.modalsActions.setModalLoading;

    const from = values.from ? formatDatabaseDate(values.from) : undefined;
    const till = values.till ? formatDatabaseDate(values.till) : undefined;

    let scheduleId = schedule ? schedule.id : undefined;
    if (duplicate) {
      scheduleId = undefined;
    }

    dispatch(setModalLoading(true));
    createPracticeTimesDraft({
      ...(scheduleId ? { id: scheduleId } : {}),
      name: values.name,
      from: from,
      till: till,
      active: values.active,
      ...(duplicate ? { duplicate_entries_of: schedule?.id } : {}),
    })
      .unwrap()
      .then((schedule: PracticeTimesSchedule) => {
        resetForm();
        dispatch(
          BasketballPracticeTimesSlice.actions.setActiveScheduleId(schedule.id)
        );
        dispatch(closeModal());
      })
      .finally(() => {
        dispatch(setModalLoading(false));
      });
  };

  return (
    <CustomForm
      key={`add-edit-practice-times-schedule-form-${
        schedule ? schedule.id : 'new'
      }`}
      formId={`add-edit-practice-times-schedule-form-${
        schedule ? schedule.id : 'new'
      }`}
      fields={[
        {
          name: 'name',
          label: t('name'),
          type: 'text',
          initalValue: schedule?.name,
          rules: [
            {
              required: true,
              message: t('form_errors.name'),
            },
          ],
        },
        {
          name: 'from',
          label: t('from'),
          type: 'date',
          initalValue: schedule?.from,
          rules: [
            {
              type: 'date',
              message: t('form_errors.date'),
            },
          ],
        },
        {
          name: 'till',
          label: t('till'),
          type: 'date',
          initalValue: schedule?.till,
          rules: [
            {
              type: 'date',
              message: t('form_errors.date'),
            },
          ],
        },
        {
          name: 'active',
          label: t('active'),
          type: 'checkbox',
          initalValue: schedule?.active,
          extraLabel: t(
            'practices.administration.practice_times.schedules.active.description'
          ),
          rules: [],
        },
      ]}
      loading={modalState.modal.loading}
      onSubmit={onSubmit}
    />
  );
}
